module App.Timeclock {
	angular
		.module('timeclock', [
			'helpers.locationService'
		])
		.factory('TimeclockService', TimeclockService.factory())
		.controller('TimeclockController', TimeclockController)
		.controller('TimeclockButtonController', TimeclockButtonController);
}